import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

// Hover help for date labels; same wording on list columns and filters.
export const DATE_HELP = Object.freeze({
    quoteReceived: 'The date the quotation request was sent to you.',
    productionReceived: 'The date the item was added to the project.',
    deadlineDelivery: 'The estimated date for the delivery to be completed.',
    // Supplier flow: the supplier ships to the finisher, not to the customer.
    supplierDispatch: 'The date you plan to ship this order to the finisher.',
    supplierDelivery: 'The date you expect the shipment to arrive at the finisher.',
})

// Label with an info icon that shows the help text on hover (same pattern as
// the expected dispatch / delivery date tooltips).
const InfoLabel = ({ label, info }) => (
    <Tooltip title={info}>
        <span>{label} <InfoCircleOutlined /></span>
    </Tooltip>
)

InfoLabel.propTypes = {
    label: PropTypes.node.isRequired,
    info: PropTypes.node.isRequired,
}

export default InfoLabel
